<template>
  <v-container>
    <v-slide-x-transition>
      <v-data-table
        :headers="cmp_headers"
        :items="cmp_items"
        class="elevation-1"
        :loading="cmpLoading"
        loading-text="Загружаю данные"
        item-key="COMP_ID"
        show-select
        single-select
        :search="compSearch"
        locale="ru-RU"
        dense
        :value="value"
        @input="setValue"
      >
        <template v-slot:top>
          <v-toolbar color="primary" dark dense>
            <v-toolbar-title>Компоненты</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-text-field
              v-model="compSearch"
              append-icon="mdi-magnify"
              label="Искать"
              single-line
              hide-details
              clearable
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn icon @click="setValue([])" v-if="mode == 'compact'"><v-icon small>mdi-close</v-icon></v-btn>
          </v-toolbar>
        </template>
        <template v-slot:no-data>
          Нет данных
        </template>
      </v-data-table>
    </v-slide-x-transition>
  </v-container>
</template>

<script>
import { UI_SNACKBAR } from '@/store/actions/ui'
import axios from 'axios'

export default {
  name: 'refComponentsTable',
  props: ['value', 'mode'],
  data () {
    return {
      cmp_headers: [
        {
          text: 'Наименование',
          value: 'COMP_NAME'
        },
        {
          text: 'Код',
          value: 'COMP_CODE'
        }
      ],
      cmpLoading: false,
      compSearch: '',
      cmp_items: []
    }
  },

  computed: {},
  watch: {
    value (val) {
      if (!val || !val.length || !val[0].COMP_ID) return
      const curr = this.cmp_items.findIndex(itm => itm.COMP_ID === val[0].COMP_ID)
      if (curr >= 0) {
        if (val[0].action === 'delete') {
          this.cmp_items.splice(curr, 1)
          this.setValue([])
          return
        }
        this.cmp_items.splice(curr, 1, val[0])
      } else {
        this.cmp_items.push(val[0])
      }
    }
  },
  mounted: function () {
    if (this.cmp_items.length === 0) {
      this.getCmpList()
    }
  },
  methods: {
    setValue (val) {
      this.$emit('input', val)
    },
    getCmpList () {
      const self = this
      this.cmpLoading = true
      axios({
        url: '/api/org/references/getComponentsList.php',
        method: 'POST'
      })
        .then(resp => {
          if (resp.data.error === 'ok') {
            self.cmp_items.splice(0, self.cmp_items.length, ...resp.data.data)
          } else {
            self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка компонентов: \n ${resp.data.error_text}` })
          }
        })
        .catch((err) => {
          self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка компонентов: \n ${err}` })
        })
        .finally(
          this.cmpLoading = false
        )
    }
  }
}

</script>
